import { useEffect, useRef, useState } from "react";

/** Draw-with-your-finger signature box. Calls onChange(dataUrl | "") as the kid signs. */
export default function SignaturePad({ onChange, height = 160 }) {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvas.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.6;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#2C342A";
  }, [height]);

  const point = (e) => {
    const r = canvas.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const down = (e) => {
    e.preventDefault();
    canvas.current.setPointerCapture?.(e.pointerId);
    drawing.current = true;
    const { x, y } = point(e);
    const ctx = canvas.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + 0.1, y + 0.1);
    ctx.stroke();
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const { x, y } = point(e);
    const ctx = canvas.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange?.(canvas.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvas.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange?.("");
  };

  return (
    <div>
      <div className="relative rounded-xl border-2 border-dashed border-[#E4E2DC] bg-white">
        <canvas ref={canvas} style={{ width: "100%", height, touchAction: "none", display: "block" }}
                onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
                data-testid="signature-pad" />
        {empty && (
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-[#A6ABA3]">
            Sign here with your finger
          </span>
        )}
      </div>
      <button type="button" onClick={clear} className="mt-1 text-xs text-[#707A6E] underline">Clear</button>
    </div>
  );
}
